import { render, staticRenderFns } from "./goodsStatistics.vue?vue&type=template&id=2235769a&scoped=true&"
import script from "./goodsStatistics.vue?vue&type=script&lang=js&"
export * from "./goodsStatistics.vue?vue&type=script&lang=js&"
import style0 from "./goodsStatistics.vue?vue&type=style&index=0&id=2235769a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2235769a",
  null
  
)

export default component.exports